import { Flex } from "@chakra-ui/layout";
import { ChakraProps, Checkbox, Tag, TagLabel } from "@chakra-ui/react";

import { ContactDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";
import { userName } from "@bcasmart/doxecure-commons/doxecureFunctions";
import { $ok } from "foundation-ts/commons";

import { CardDescription } from "@components/Cards/CardDescription";
import { G1Icon } from "@utils/icons";
import { CustomItemType } from "@utils/TypesAndConstants";

interface ContactCardProps extends ChakraProps {
    item: ContactDto;
    itemStyle: CustomItemType;
    displayIcon?: boolean;
    selectable?: boolean;
    selected?: boolean;
    tagNames?: string[];
    onToggleSelect?: (item: ContactDto) => void;
    onViewItemClick?: () => void;
    onItemClick?: () => void;
    onRemoveItemClick?: () => void;
}

export const ContactCard = (props: ContactCardProps) => {
    const {
        item,
        itemStyle,
        displayIcon,
        selectable,
        selected,
        tagNames,
        onToggleSelect,
        onRemoveItemClick,
        onItemClick,
        onViewItemClick,
        ...rest
    } = props ;

    const phoneNumber = $ok(item.contact.phone) ? ` (${item.contact.phone})` : '';
    const deletable = item.deletable ?? true;
    const tagColor = (item.status === 'badRecipient') ? 'red.200' : undefined;
    const status = (item.status === 'badRecipient') ? 'Mauvais destinataire' : undefined;

    const tagElements = tagNames?.map(t => (
        <Tag backgroundColor="transparent" borderWidth="1px" borderColor="gray.400" color="gray.400" borderRadius="xl" height="1.5rem">
            <TagLabel>{t}</TagLabel>
        </Tag>
    ));

    return (
        <Flex
            p="2"
            width="100%"
            minH="6em"
            alignItems="flex-start"
            borderTop={itemStyle.borderTop ?? "1px"}
            borderTopColor={itemStyle.borderTopColor ?? "inherit"}
            _hover={$ok(onItemClick) ? itemStyle.hover : undefined}
            _focus={itemStyle.select}
            cursor={$ok(onItemClick) ? "pointer" : "default"}
            onClick={onItemClick}
            {...rest}
        >
            {selectable && deletable && (
                <Checkbox
                    alignSelf="center"
                    isChecked={!!selected}
                    onChange={(e) => { e.stopPropagation(); onToggleSelect?.(item); }}
                    onClick={(e) => e.stopPropagation()}
                />
            )}

            <CardDescription alignSelf="center" width="100%" title={`${userName(item.contact)}`} moreInfos={`${item.contact.email}${phoneNumber}`} tags={tagElements} />

            <Flex direction="column" alignItems="flex-end" alignSelf="stretch" justifyContent={$ok(status) ? "flex-start" : "center"} gap="1" flexShrink={0}>
                {$ok(status) && (
                    <Tag size="sm" variant="outline" boxShadow="none" borderRadius="full" border="1px solid" borderColor={tagColor} px={3} py={1}>
                        <TagLabel fontSize="xs" color={tagColor} fontWeight="600">
                            {status}
                        </TagLabel>
                    </Tag>
                )}
                {displayIcon && (
                    <Flex alignItems="center" justifyContent="center" gap="2" margin="5%" color={itemStyle.iconColor ?? "inherit"}>
                        <G1Icon.View size="20px" cursor="pointer" onClick={onViewItemClick} />
                        {$ok(onRemoveItemClick) && <G1Icon.Minus size="16px" cursor="pointer" onClick={onRemoveItemClick} />}
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
};